import {AuthGuard} from '../../shared/guards/AuthGuard';
import {FinancialListPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const FinancialListPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <FinancialListPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};